import { ContainerSection } from "@/main/components/shared/styles";
import styled from "styled-components";

export const Container = styled(ContainerSection)``;
